import { useSyncExternalStore } from 'react';

/** Panel teması (docs/56 Faz 0): açık, koyu ya da sistem ayarı (varsayılan). */
export type Tema = 'acik' | 'koyu' | 'sistem';

const ANAHTAR = 'panel-tema';
const dinleyiciler = new Set<() => void>();

function oku(): Tema {
  try {
    const v = localStorage.getItem(ANAHTAR);
    return v === 'acik' || v === 'koyu' ? v : 'sistem';
  } catch {
    return 'sistem';
  }
}

/** Seçimi belgeye uygular: sistemde `data-theme` yok, CSS medya sorgusu karar verir. */
export function temayiUygula(t: Tema = oku()) {
  const kok = document.documentElement;
  if (t === 'sistem') kok.removeAttribute('data-theme');
  else kok.setAttribute('data-theme', t === 'koyu' ? 'dark' : 'light');
}

export function temaSec(t: Tema) {
  try {
    if (t === 'sistem') localStorage.removeItem(ANAHTAR);
    else localStorage.setItem(ANAHTAR, t);
  } catch {
    // Depo kapalıysa yalnız bu oturumda geçerli
  }
  temayiUygula(t);
  sonSecim = t;
  dinleyiciler.forEach((f) => f());
}

let sonSecim: Tema = oku();

export function useTema(): Tema {
  return useSyncExternalStore(
    (f) => {
      dinleyiciler.add(f);
      return () => dinleyiciler.delete(f);
    },
    () => sonSecim,
  );
}
